import "./StatCard.css";

const StatCard = ({
  title,
  value,
  bgGradient,
  iconBg = "rgba(255,255,255,.12)",
  trend = "+0.0%",
  positive = true,
  Icon,
  index = 0,
}) => {
  return (
    <div
      className="stat-card"
      style={{
        background: bgGradient,
        animationDelay: `${index * 0.1}s`,
      }}
    >
      <div className="stat-card-inner">
        <div className="stat-card-circle"></div>
        <div className="stat-card-circle-sm"></div>

        <div className="stat-card-content">
          <div>
            <div className="stat-card-icon" style={{ background: iconBg }}>
              <Icon size={22} color="#fff" strokeWidth={2.2} />
            </div>

            <h6 className="stat-card-title">{title}</h6>

            <h2 className="stat-card-value">{value}</h2>
          </div>

          {/* <div
            className={`stat-card-badge ${positive ? "positive" : "negative"}`}
          >
            {trend}

            {positive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
